import { defineMessages } from 'react-intl';

export default defineMessages({
    watercraftOperatorx: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperatorx',
        defaultMessage: 'Watercraft Operator {watercraftOperatorNumber}'
    },
    yearsOfExperience: {
        id: 'ml.quoteandbind.pup.additionalInformation.Years Operating Watercraft',
        defaultMessage: 'Years Operating Watercraft'
    },
    watercraftOperatorPound: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperator.pound',
        defaultMessage: '#'
    },
    watercraftOperatorLicenseNum: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperator.License Number',
        defaultMessage: 'License Number'
    },
    watercraftOperatorStateLicensed: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperator.State Licensed',
        defaultMessage: 'State Licensed'
    },
    watercraftStateLicensedTooltipLabel: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperator.What if I don\'t have a US license?',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    watercraftStateLicensedTooltipDesc: {
        id: 'ml.quoteandbind.pup.additionalInformation.watercraftOperator.Select DC, Canada, US Territories or Foreign as your state licensed.',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
});
